<!--大用户 - 大用户报警管理  -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear trim />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear trim />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="处理状态">
              <a-select v-model="query.processingStatus" placeholder="请选择处理状态" allow-clear>
                <a-select-option :value="1">未处理</a-select-option>
                <a-select-option :value="2">已处理</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="报警类型">
              <a-select v-model="query.waterType" placeholder="请选择处理状态" allow-clear>
                <a-select-option :value="1">水量异常</a-select-option>
                <a-select-option :value="2">数据中断</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 第二排-操作按钮 -->
          <a-col :md="12" :sm="12" style="display: flex;">
            <div style="margin-bottom: 20px;">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button style="margin-left: 12px" @click="deleteSelectRow()" type="danger">删除</a-button>
              <a-button style="margin-left: 12px" @click="alarmSettingsAll" type="primary">报警设置</a-button>
              <a-button style="margin-left: 12px" @click="batchDispose" type="primary">批量处理</a-button>
              <!-- <a-button type="primary" style="margin-left: 12px" v-action:export>导出</a-button> -->
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 1500 }">
      <span slot="waterTypeName" slot-scope="text">
        <a-tag :color="text == '水量异常' ? '#f12b35' : '#ff912b'"> {{ text }}</a-tag>
      </span>
      <span slot="processingStatus" slot-scope="text">
        <a-tag :color="text == '1' ? '#01db0a' : '#bbbbbb'"> {{ text == '1' ? '未处理' : '已处理' }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="openDispose(record)" v-if="record.processingStatus == 1">处理</a>
        <a style="pointer-events:none; color: #bbbbbb;" v-else>处理</a>
      </span>
    </a-table>

    <!-- 报警设置 -->
    <a-modal title="报警设置" :dialog-style="{ top: '240px' }" :width="600" :maskClosable="false"
      v-model="alarmSettingsVisible" @ok="alarmSettingsOk" @cancel="alarmSettingsCancel">
      <div>
        <span class="proportion">水量异常报警设置</span>
        <a-form :form="addOrUpdateForm" class="tenant-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <!-- 正波动报警比例 -->
          <a-form-item label="正波动报警比例">
            <a-input placeholder="请输入正波动报警比例" type="number" min="0" style="width: 90%;margin-left: 10px;"
              v-decorator="['positiveFluctuations']" trim @keypress="handleKeyPress" />
            <span>&nbsp;%</span>
          </a-form-item>
          <!-- 反波动报警比例 -->
          <a-form-item label="反波动报警比例">
            <a-input placeholder="请输入反波动报警比例" type="number" min="0" style="width: 90%; margin-left: 10px;"
              v-decorator="['antiVolatility']" trim @keypress="handleKeyPress" />
            <span>&nbsp;%</span>
          </a-form-item>
          <a-form-item label="是否启动">
            <a-switch v-decorator="['alarmActivated', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>

    <!-- 批量处理 -->
    <a-modal title="批量处理" :dialog-style="{ top: '240px' }" :width="600" :maskClosable="false"
      v-model="batchDisposeVisible" @ok="batchDisposeOk" @cancel="batchDisposeCancel">
      <a-form :form="batchDisposeForm" class="tenant-form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="处理范围">
          <a-radio-group v-decorator="['disposeType', { initialValue: 'batch' }]">
            <a-radio value="batch">批量处理（{{ selectedRows.length > 0 ? `已选${selectedRows.length}条` : '勾选的数据' }}）</a-radio>
            <a-radio value="all">全部处理</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="处理描述">
          <a-textarea v-decorator="['processDescription', { rules: [{ required: true, message: '请输入处理描述' }] }]"
            :rows="6" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common' //选项式混合导入
import storage from 'store'

const columns = [ //表头参数
  {
    title: '用户编码',
    dataIndex: 'userCode',
    width: '120px', // 固定操作列宽度
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '用户名称',
    dataIndex: 'userName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '报警地址',
    dataIndex: 'userAddress',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表编号',
    dataIndex: 'waterMeterNumber',
    width: '150px',
    ellipsis: true
  },
  {
    title: '报警类型',
    dataIndex: 'waterTypeName',
    width: '150px',
    ellipsis: true,
    scopedSlots: { customRender: 'waterTypeName' }
  },
  {
    title: '报警说明',
    dataIndex: 'alarmInstructions',
    width: '250px',
    ellipsis: true
  },
  {
    title: '上期用水量',
    dataIndex: 'previousUsage',
    width: '150px',
    ellipsis: true
  },
  {
    title: '上期采集时间',
    dataIndex: 'lastIssueTime',
    width: '150px',
    ellipsis: true
  },
  {
    title: '本期用水',
    dataIndex: 'currentUsage',
    width: '150px',
    ellipsis: true
  },
  {
    title: '本期采集时间',
    dataIndex: 'currentGatherTime',
    width: '150px',
    ellipsis: true
  },
  {
    title: '开始报警时间',
    dataIndex: 'startTime',
    width: '150px',
    ellipsis: true
  },
  // {
  //   title: '最新报警时间',
  //   dataIndex: 'latestTime',
  //   width: '150px',
  //   ellipsis: true
  // },
  {
    title: '处理状态',
    dataIndex: 'processingStatus',
    width: '150px',
    ellipsis: true,
    scopedSlots: { customRender: 'processingStatus' }
  },
  {
    title: '处理人',
    dataIndex: 'processingPersonnel',
    width: '150px',
    ellipsis: true
  },
  {
    title: '处理描述',
    dataIndex: 'processDescription',
    width: '150px',
    ellipsis: true
  },
  {
    title: '处理时间',
    dataIndex: 'processingTime',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: '150px', // 固定操作列宽度
    scopedSlots: { customRender: 'action' }
  }
]
const tenantIdStorage = storage.get('tenantId') //获取租户id

export default {
  mixins: [mixinViewModule],
  name: 'AllUserPage',
  data () {
    return {
      needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '/smart-water-major-users/major/users/alarm/alarm_info/select/page', //查询url
      querySetting: '/smart-water-major-users/major/data/dictionary/select/name/alarm', //查询设置
      addOrUpdateUrl: '/smart-water-major-users/major/data/dictionary/update/insert/list', //新增or编辑url
      deleteUrl: '/smart-water-major-users/major/users/alarm/alarm_info/list/delete', //删除url
      // disposeUrl: '/smart-water-major-users/major/users/alarm/alarm_info/update/insert', //处理url
      batchDisposeUrl: '/smart-water-major-users/major/users/alarm/update/chuli/list', //批量处理url
      batchDisposeAllUrl: '/smart-water-major-users/major/users/alarm/update/chuli/all/list', //全部处理url
      exportDataUrl: '', //导出url
      exportFileName: '总用户列表.xlsx', //导出名称
      query: { //查询对象
        userCode: '',
        processingStatus: null
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      disposeForm: this.$form.createForm(this, { name: 'disposeForm' }),
      //页面内属性
      alarmSettingsVisible: false, //报警设置
      alarmData: [], //报警设置集合
      disposeVisible: false,
      disposeData: {}, //处理对象
      batchDisposeVisible: false, //批量处理
      batchDisposeForm: this.$form.createForm(this, { name: 'batchDisposeForm' }),
    }
  },
  created () {
    if (this.$route.query.userCode) {
      this.query.userCode = this.$route.query.userCode;
      this.query.processingStatus = 1;
      this.queryList();
      this.clearRouteParams();
    } else {
      this.queryList();
    }
  },
  methods: {
    // 阻止输入减号等非法字符
    handleKeyPress (e) {
      // 获取按键的字符码
      const charCode = e.charCode || e.which || e.keyCode;
      // 只允许数字字符 (0-9)
      if (charCode < 48 || charCode > 57) {
        e.preventDefault();
        return false;
      }
    },
    //设置页面名称
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}大用户报警管理`)
    },
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      // 清除路由参数但不刷新页面
      this.queryList()
    },
    // 清除路由参数但不刷新页面
    clearRouteParams () {
      this.$router.replace({
        path: this.$route.path,
        query: {}
      })
    },
    querySettingList () {
      this.$http.get(this.querySetting)
        .then((res) => {
          console.log('获取设置列表:', res.data);
          this.alarmData = res.data;

          // 构建表单设置对象
          const formValues = {};

          this.alarmData.forEach((item) => {
            // 只处理已知的字段，避免设置不存在的表单字段
            const knownFields = ['alarmActivated', 'antiVolatility', 'positiveFluctuations'];
            if (knownFields.includes(item.keyName)) {
              // 特殊处理 alarmActivated 字段，转换为 boolean
              formValues[item.keyName] = item.keyName === 'alarmActivated'
                ? item.keyValue?.toLowerCase().trim() === 'true'
                : item.keyValue;
            }
          });
          console.log(formValues);

          // 一次性设置所有表单值，避免多次渲染
          if (Object.keys(formValues).length > 0) {
            this.addOrUpdateForm.setFieldsValue(formValues);
          }
          console.log(this.addOrUpdateForm.getFieldsValue());

        })
        .catch(error => {
          console.error('获取设置列表失败:', error);
          this.$message.error('获取设置失败');
        });
    },
    alarmSettingsAll () {
      this.querySettingList();
      this.alarmSettingsVisible = true;
    },
    // 模态框取消
    alarmSettingsCancel () {
      this.alarmSettingsVisible = false;
      this.addOrUpdateForm.resetFields();
    },
    alarmSettingsOk () {
      const formValues = this.addOrUpdateForm.getFieldsValue();
      let data;
      if (this.alarmData) {
        // 如果已有数据，构建更新对象
        data = this.alarmData.map(item => {
          const value = formValues[item.keyName];
          return {
            id: item.id,
            keyDictionary: item.keyName,
            name: item.keyName,
            tenantId: tenantIdStorage,
            keyValue: value !== undefined ? String(value) : item.value
          };
        });
      } else {
        data = [
          {
            keyDictionary: 'positiveFluctuations',
            name: 'positiveFluctuations',
            tenantId: tenantIdStorage,
            keyValue: formValues.positiveFluctuations
          },
          {
            keyDictionary: 'antiVolatility',
            name: 'antiVolatility',
            tenantId: tenantIdStorage,
            keyValue: formValues.antiVolatility
          },
          {
            keyDictionary: 'alarmActivated',
            name: 'alarmActivated',
            tenantId: tenantIdStorage,
            keyValue: formValues.value
          },

        ]; //创建新增报警管理对象
      }
      console.log(data);
      this.$http.post(this.addOrUpdateUrl, data).then((res) => {
        this.$message.success('设置成功');
        this.alarmSettingsCancel();
      }).catch(error => {
        this.$message.error('设置失败');
        console.error(error);
      });
    },
    //打开处理框
    openDispose (item) {
      this.disposeData = item; //获取处理对象
      this.batchDisposeVisible = true;
    },
    //处理确认
    //批量处理
    batchDispose () {
      this.batchDisposeVisible = true;
    },
    //批量处理确认
    batchDisposeOk () {
      this.batchDisposeForm.validateFields((err, values) => {
        if (err) {
          return;
        }
        
        const isAllDispose = values.disposeType === 'all';
        let data = {};
        let url = this.batchDisposeUrl;

        if (isAllDispose) {
          // 全部处理
          url = this.batchDisposeAllUrl;
          data = {
            processDescription: values.processDescription
          };
        } else if (this.disposeData && this.disposeData.id) {
          // 单条处理
          data = {
            ids: [this.disposeData.id],
            processDescription: values.processDescription
          };
        } else {
          // 批量处理（勾选或按查询条件）
          data = {
            ...this.query,
            processDescription: values.processDescription
          };
          if (this.selectedRows.length > 0) {
            data.ids = this.selectedRows;
          }
        }
        
        data.processingPersonnel = this.$store.getters.userInfo.realName;
        this.$http.put(url, data).then((res) => {
          this.$message.success(isAllDispose ? data.message + '条处理成功' : '批量处理成功');
          console.log(res);
          this.queryList();
        }).catch(error => {
          this.$message.error(isAllDispose ? '全部处理失败' : '批量处理失败');
          console.error(error);
        }).finally(() => {
          this.disposeData = {};
          this.batchDisposeVisible = false;
          this.batchDisposeForm.resetFields();
        });
      });
    },
    //批量处理取消
    batchDisposeCancel () {
      this.batchDisposeVisible = false;
      this.batchDisposeForm.resetFields();

    },

  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.proportion {
  font-size: 15px;
  font-weight: bold;
  display: block;
  margin-bottom: 20px;
}
</style>
